/**
 * Pure helpers for the file manager's *locations*: the caller's own files plus
 * the file folder of every collaboration group they belong to. Each location
 * is a "source" with its own endpoints; files carry the key of the source they
 * came from so one flat list can hold all of them. No I/O here.
 */

export const PERSONAL_SOURCE = "me";

/** Key of the source that holds a group's files. */
export const groupSourceKey = (groupId) => `group-${groupId}`;

/**
 * The groups that have a file folder: collaboration groups only. The API
 * serialises the flag as `system_group`; older payloads used `systemGroup`.
 */
export const collaborationGroups = (groups = []) =>
  (Array.isArray(groups) ? groups : []).filter(
    (group) => group && group.id != null && !(group.system_group ?? group.systemGroup ?? false)
  );

/** Every file tagged with the source it belongs to (the tag is never sent to the API). */
export const tagFiles = (files = [], sourceKey) =>
  files.map((file) => ({ ...file, _source: sourceKey }));

/** A location: which source, and which folder inside it (null = its root). */
export const locationOf = (source, path = null) => ({ source, path: path ?? null });

export const sameLocation = (a, b) =>
  (a?.source ?? null) === (b?.source ?? null) && (a?.path ?? null) === (b?.path ?? null);

/** Files of one location: same source and same folder (missing folder_path = root). */
export const filesAt = (files = [], location) =>
  files.filter(
    (file) => file._source === location?.source && (file.folder_path ?? null) === (location?.path ?? null)
  );
